import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { FC, useEffect } from 'react';
import { Box, DialogContent, TextField, Typography } from '@mui/material';
import { useFormik } from 'formik';
import { useDispatch } from 'react-redux';
import { updateInvoiceCommentRequest } from 'redux/reducers/invoiceManagement/reducer';
import { TInvoiceCommentDialogProps } from './types';

export const InvoiceCommentDialog: FC<TInvoiceCommentDialogProps> = ({
	open,
	setClose,
	data,
	invoiceListRequestPayload,
}) => {
	const dispatch = useDispatch();

	const formik = useFormik({
		initialValues: {
			commentContent: '',
		},
		enableReinitialize: true,
		onSubmit: (values) => {
			if (!data) return;

			dispatch(
				updateInvoiceCommentRequest({
					body: {
						invoice_id: data.invoice_id,
						comment_content: values.commentContent,
					},
					invoiceListRequest: invoiceListRequestPayload,
				}),
			);
			formik.resetForm();
			setClose();
		},
	});

	useEffect(() => {
		if (!open) return;
		formik.setFieldValue('commentContent', data?.comment ?? '');
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [open, data]);

	return (
		<Dialog
			open={open}
			sx={{
				'& .MuiDialog-paper': {
					width: '600px',
					maxWidth: '600px',
					borderRadius: '12px',
				},
			}}
		>
			<DialogTitle color="primary">Add or edit comments for the invoice</DialogTitle>
			<form onSubmit={formik.handleSubmit}>
				<DialogContent
					sx={{
						p: '0 12px 0px 12px',
					}}
				>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							gap: '16px',
						}}
					>
						{data && (
							<Typography component="div" color="primary" sx={{ fontSize: '0.9rem' }}>
								Client: <b>{data.client}</b>
							</Typography>
						)}
						<TextField
							id="commentContent"
							name="commentContent"
							size="small"
							label="Comment"
							value={formik.values.commentContent}
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							multiline
							rows={4}
							fullWidth
							error={formik.touched.commentContent && Boolean(formik.errors.commentContent)}
							helperText={formik.touched.commentContent && formik.errors.commentContent}
						/>
					</Box>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => {
							formik.resetForm();
							setClose();
						}}
					>
						Cancel
					</Button>
					<Button type="submit" autoFocus>
						Save
					</Button>
				</DialogActions>
			</form>
		</Dialog>
	);
};
